<button class="buttonClose" (click)="close()">
  <svg class="c-icon buttonClose__icon">
    <use xlink:href="#ic-sweet-close" />
  </svg>
</button>